import React, { useState } from 'react'
import { apiPut } from '../../API/Api_Url';
import { toast } from 'react-toastify';

function UpdateProfile({ Name, Email, Number, setName, setEmail, setNumber,GetUserProfile }) {
    const [IsUploading, setIsUploading] = useState(false);
    const UpdateProfile = async () => {
        try {
            let data = {
                name: Name,
                email: Email,
                phone: Number
            }
            setIsUploading(true);
            const response = await apiPut('api/user/update', data);
            if (response?.data) {
                toast.success("Requirement uploaded successfully!");
                GetUserProfile()
                setIsUploading(false);
            }
            else {
                setIsUploading(false);
                toast.error(response?.message);
            }
        } catch (error) {
            setIsUploading(false);
            console.error('Error fetching data:', error);
        }
    }

    return (
        <>
            <div className=" mx-auto bg-white p-8 rounded-xl shadow-lg">
                <h2 className="text-2xl font-bold mb-6 text-gray-900 border-b pb-2">
                    Update Profile
                </h2>

                <div className="space-y-5">
                    <div>
                        <label className="block text-gray-700 font-medium mb-1">Name</label>
                        <input
                            type="text"
                            name="name"
                            value={Name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter your name"
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 font-medium mb-1">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={Email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 font-medium mb-1">Number</label>
                        <input
                            type="tel"
                            name="number"
                            value={Number}
                            onChange={(e) => setNumber(e.target.value)}
                            placeholder="Enter your phone number"
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    <button
                        onClick={() => { UpdateProfile() }}
                        disabled={IsUploading}
                        className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold py-2 rounded-lg shadow-md hover:from-blue-600 hover:to-blue-700 transition-all duration-300"
                    >
                        {IsUploading ? (
                            <div className="flex items-center justify-center">
                                <svg
                                    className="animate-spin h-5 w-5 text-white mr-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                    ></path>
                                </svg>
                                Loading...
                            </div>
                        ) : (
                            "Submit"
                        )}
                    </button>
                </div>
            </div>

        </>
    )
}

export default UpdateProfile